
import { Base } from '../base-component';
import './shopping-promo.component.scss';

export class ShoppingPromo extends Base {

	constructor(element: Element) {

		super(element);

	}

	init() {

	}

	bindEvents() {

	}

}



// WEBPACK FOOTER //
// ./components/shopping-promo/shopping-promo.component.ts